import React, { useEffect, useRef, useCallback, useMemo, useState, useImperativeHandle, forwardRef } from 'react';

export default forwardRef(function (props, ref) {
    const [selectedVoice, setSelectedVoice] = useState(null);

    const canSpeak = useCallback(() => {
        if ('speechSynthesis' in window) {
            return true;
        }
        return false;
    }, []);

    const loadVoices = useCallback(() => {
        const availableVoices = window.speechSynthesis.getVoices();

        // console.log(
        //     'ant-log-vietnam-voices : ',
        //     availableVoices.filter((voice) => voice.lang === 'vi-VN')
        // );

        const defaultVietnameseVoice = availableVoices.find((voice) => voice.lang === 'vi-VN' && voice.name.toLowerCase().includes('female'));
        if (defaultVietnameseVoice) {
            setSelectedVoice(defaultVietnameseVoice);
            return defaultVietnameseVoice;
        } else {
            const anyVietnameseVoice = availableVoices.find((voice) => voice.lang === 'vi-VN');
            if (anyVietnameseVoice) {
                setSelectedVoice(anyVietnameseVoice);
                return anyVietnameseVoice;
            }
        }
    }, []);

    const speak = useCallback(
        (text, times) => {
            if ('speechSynthesis' in window) {
                const utterance = new SpeechSynthesisUtterance(text);

                let cVoice = selectedVoice;
                if (!selectedVoice) cVoice = loadVoices();
                if (cVoice) {
                    utterance.voice = cVoice;
                }
                utterance.rate = props.rate ? props.rate : 1;
                utterance.volume = props.volume ? props.volume : 1;
                utterance.lang = 'vi-VN';

                if (times && times > 1) {
                    for (let i = 0; i < times; i++) {
                        window.speechSynthesis.speak(utterance);
                    }
                } else window.speechSynthesis.speak(utterance);
            }
        },
        [selectedVoice, loadVoices]
    );

    useEffect(() => {
        loadVoices();
        window.speechSynthesis.onvoiceschanged = loadVoices;
    }, []);

    useImperativeHandle(ref, () => ({
        canSpeak: canSpeak,
        speak: speak
    }));

    return <div />;
});
